// A `Footer` komponens az oldal alján megjelenő láblécet tartalmazza, amely bemutatja az alkalmazás nevét, elérhetőségi adatokat és közösségi linkeket.
import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer: React.FC = () => {
  // Az e-mail cím dinamikus összefűzése a spamszűrés érdekében.
  const emailUser = 'sajben.dani';
  const emailDomain = 'gmail.com';
  const fullEmail = `${emailUser}@${emailDomain}`;
  return (
    <Box
      sx={{
        backgroundColor: '#1c1c1c',
        color: 'white',
        py: 3,
        mt: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            {/* Alkalmazás neve és leírása */}
            <Typography variant="h6" gutterBottom>
              Workout Logger
            </Typography>
            <Typography variant="body2">
              Keep track of your exercises and progress efficiently. Stay motivated and achieve your fitness goals!
            </Typography>
          </Grid>

          {/* Kapcsolatfelvételi adatok és közösségi linkek */}
          <Grid item xs={12} sm={4}>
          <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2">
              Email: <Link href={`mailto:${fullEmail}`} color="inherit">{fullEmail}</Link>
            </Typography>
          </Grid>
          
          {/* Ikonok a közösségi média eléréséhez, github */}
          <Grid item xs={12} sm={4}>
          <Typography variant="h6" gutterBottom>
              Social
            </Typography>
            <Typography variant="body2" sx={{ padding: '0px 0px 10px 0px' }}>
              Check out other projects on GitHub:
            </Typography>
          <IconButton
              href="https://github.com/SajbenDani"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'inherit', fontSize: '3rem' }}
            >
              <GitHubIcon fontSize="inherit" />
            </IconButton>
          </Grid>
        </Grid>
        <Box mt={4} textAlign="center">
          <Typography variant="body2">
            Made by Sajben Daniel © {new Date().getFullYear()} | All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
